import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=3066cfaa&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3066cfaa')) {
      api.createRecord('3066cfaa', component.options)
    } else {
      api.reload('3066cfaa', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=3066cfaa&", function () {
      api.rerender('3066cfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nbEpH5WIhSRY/JS/pricelisthelp.vue"
export default component.exports